"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var vue_property_decorator_1 = require("vue-property-decorator");
var vuex_1 = require("vuex");
var EmbeddedComplete = /** @class */ (function (_super) {
    tslib_1.__extends(EmbeddedComplete, _super);
    function EmbeddedComplete() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbeddedComplete = tslib_1.__decorate([
        vue_property_decorator_1.Component({
            computed: tslib_1.__assign(tslib_1.__assign({}, vuex_1.mapState([
                'caseNumber'
            ])), vuex_1.mapGetters([
                'brandLinks'
            ]))
        })
    ], EmbeddedComplete);
    return EmbeddedComplete;
}(vue_property_decorator_1.Vue));
exports.default = EmbeddedComplete;
